import { render, staticRenderFns } from "./PaperAndPenIcon.vue?vue&type=template&id=2512b41b&"
import script from "./PaperAndPenIcon.vue?vue&type=script&lang=ts&"
export * from "./PaperAndPenIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports